import { createContext } from "react";

import { FieldType } from "../constants";
import { RadioButtonType } from "../components/dataForm/fieldRadioButtons";

export interface DataFormFieldSetting {
	field: string;
	placeholder?: string;
	title?: string;
	type?: FieldType;
	tooltip?: string;
	multiCheckData?: { id: any; label: string }[];
	dropdownData?: { id: any; label: string }[];
	radioData?: RadioButtonType[];
	accessor?: (data: any) => any;
	initValuesFn?: (data: any) => any;
	defaultInitValuesFn?: (data: any) => any;
	isMandatory?: boolean;
	isDisabled?: boolean;
	isDisabledFn?: (data: any) => any;
	isAnIsDisabledTrigger?: boolean;
}

export const DataFormFieldContext = createContext({
	isVerticalLayout: false as boolean,
	hasFieldTitle: true as boolean,
	fieldSetting: { field: "" } as DataFormFieldSetting,
	triggerFn: ((data: any) => {}) as ((data: any) => void) | undefined,
	isDisabledTrigger: false,
});

export const DataFormFieldProvider = ({
	children,
	isVerticalLayout = false,
	hasFieldTitle = true,
	fieldSetting,
	triggerFn,
	isDisabledTrigger = false,
}: {
	children: any;
	isVerticalLayout?: boolean;
	hasFieldTitle?: boolean;
	fieldSetting: DataFormFieldSetting;
	triggerFn?: (data: any) => void;
	isDisabledTrigger?: boolean;
}) => (
	<DataFormFieldContext.Provider
		value={{
			triggerFn,
			isDisabledTrigger,
			isVerticalLayout,
			hasFieldTitle,
			fieldSetting,
		}}
	>
		{children}
	</DataFormFieldContext.Provider>
);
